const appConfig = {
    authApiBase: "https://iqna6zow90.execute-api.us-east-1.amazonaws.com"
}

export default appConfig;